import axiosClient from "../config/axios";

export function fetchPaymentMethodsAsync() {
    return axiosClient.get(`/payment_methods?type=cash`)
        .then(result => result.data)
        .catch(error => new Error(error));
}
